const Domain = {
  location: window.location,
  href: window.location.href,
  protocol: window.location.protocol,
  host: window.location.host,
  hostname: window.location.hostname,
  port: window.location.port,
  search: window.location.search,
  hash: window.location.hash
};
let baseURL;
baseURL = '/cloudlive/';

let pagination = {
  pagesizes: [6, 8, 10],
  pagesize: 10,
  total: 0,
  currentpage: 1
};
export {
  Domain,
  baseURL,
  pagination
};



// WEBPACK FOOTER //
// ./src/config/globalConfig.js